import { Color } from 'csstype'
import React from 'react'
import { CidadaoListagemHipertensaoQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel'

interface AcompanhamentoCondicaoSaudeHipertensaoAccordionSectionProps {
  row: CidadaoListagemHipertensaoQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeHipertensaoAccordionSection({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeHipertensaoAccordionSectionProps>) {
  return (
    <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel
      dataUltimasVisitasDomiciliares={
        row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
      }
      qtdVisitasDomiciliares={row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.qtdVisitasDomiciliares}
      iconColor={iconColor}
    />
  )
}
